export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGNsZWFuJTIwYXJjaGl0ZWN0dXJhbCUyMGxpbmVzJTIwbGlnaHR8ZW58MHx8fHwxNzg1OTY5MDI3fDA&ixlib=rb-4.1.0&q=85",
  chapter1: "https://images.unsplash.com/photo-1650965171703-087486b3a1b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXNvcnQlMjBhcmNoaXRlY3R1cmUlMjBicmlnaHQlMjBkYXl8ZW58MHx8fHwxNzg1OTY5MDI3fDA&ixlib=rb-4.1.0&q=85",
  chapter2: "https://images.unsplash.com/photo-1723376779603-69f15cdfa034?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZXNvcnQlMjBhcmNoaXRlY3R1cmUlMjBicmlnaHQlMjBkYXl8ZW58MHx8fHwxNzg1OTY5MDI3fDA&ixlib=rb-4.1.0&q=85",
  consult: "https://images.unsplash.com/photo-1758691031036-5b7b635e30b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtYXR1cmUlMjBjb3VwbGUlMjBjb25zdWx0aW5nJTIwc21pbGluZyUyMHRydXN0d29ydGh5fGVufDB8fHx8MTc4NTk2OTAyN3ww&ixlib=rb-4.1.0&q=85",
};

export const CHAPTERS = [
  {
    number: "01",
    slug: "buying-more",
    title: "Buying More, With Your Eyes Open",
    lede: "Adding points or weeks can be genuinely smart — when the maths works and the contract serves you, not the companies sales quotas.",
    image: "chapter1",
    points: [
      "The resale market could be a viable option. The same deed often sells for 50–80% less than the developer's presentation price.",
      "Calculate cost per vacation night: purchase price amortised plus maintenance fees, divided by nights you'll truly use.",
      "Ask exactly what the new points change — booking windows, priority, exchange value — and get it in writing.",
      "Never decide in the room. Any offer that expires today is designed to expire your judgement, not the deal.",
    ],
  },
  {
    number: "02",
    slug: "selling-exiting",
    title: "Selling & Exiting, Without the Illusions",
    lede: "Most ownerships resell for far less than owners hope — some for almost nothing. A clear-eyed strategy beats a hopeful listing every time.",
    image: "chapter2",
    points: [
      "Check your developer's deed-back or surrender program first — it is often the cleanest and cheapest exit.",
      "Price from reality: search completed resale listings for your resort, not asking prices.",
      "Understand what you're selling: deeded weeks, points and right-to-use contracts transfer very differently.",
      "If the ownership is deeded, stopping payments is not an exit — it can become a collections and credit problem.",
    ],
  },
  {
    number: "03",
    slug: "choosing-a-company",
    title: "Choosing a Company You Can Trust",
    lede: "The exit and resale industry has honest operators and serial offenders. Ten minutes of verification separates them.",
    checklist: [
      "Licensed where required, and verifiable with the state regulator",
      "Payment into escrow — released only when the work is done",
      "Written contract with a named service, price and timeline",
      "Real, checkable references and a physical office",
      "No guarantee of a sale or exit — nobody can promise one",
      "A rating and complaint history you can look up independently",
    ],
  },
  {
    number: "04",
    slug: "red-flags",
    title: "The Red Flags That Cost Owners Thousands",
    lede: "Scams in this space follow scripts. Learn the script once and you'll recognise it forever.",
    checklist: [
      "Cold calls claiming a buyer is 'already waiting' for your week",
      "Large upfront fees demanded before any service is delivered",
      "Pressure to pay by wire transfer, gift card or crypto",
      "Guaranteed exit, guaranteed sale, guaranteed refund — guaranteed trouble",
      "'Specialists' who tell you to stop paying maintenance fees",
      "Companies that appeared recently with the same staff as a shuttered scam",
    ],
  },
];

export const QUIZ = [
  {
    question: "Which best describes you today?",
    options: [
      { label: "I own a vacation ownership / timeshare", scores: { sell: 1, hold: 1 } },
      { label: "I'm thinking about buying (or buying more)", scores: { buy: 2 } },
      { label: "I own and I'm trying to get out of it", scores: { exit: 3 } },
    ],
  },
  {
    question: "How often do you actually use your ownership each year?",
    options: [
      { label: "Nearly every year — we love it", scores: { buy: 1, hold: 2 } },
      { label: "Occasionally, when we can book what we want", scores: { hold: 1, sell: 1 } },
      { label: "Rarely or never — it sits unused", scores: { sell: 2, exit: 1 } },
    ],
  },
  {
    question: "How do the annual maintenance fees feel?",
    options: [
      { label: "Comfortable — good value for what we get", scores: { buy: 1, hold: 1 } },
      { label: "Rising, but manageable for now", scores: { hold: 1, sell: 1 } },
      { label: "A genuine burden on our budget", scores: { sell: 2, exit: 2 } },
    ],
  },
  {
    question: "What outcome do you most want?",
    options: [
      { label: "More holidays, more flexibility, better resorts", scores: { buy: 3 } },
      { label: "Lower costs while keeping some access", scores: { hold: 2, sell: 1 } },
      { label: "Out completely, at the lowest safe cost", scores: { exit: 3 } },
      { label: "Honestly, I'm not sure yet", scores: { hold: 2 } },
    ],
  },
  {
    question: "Has a resale or exit company approached you?",
    options: [
      { label: "Yes — they asked for a large upfront fee", scores: { exit: 1 }, flag: "upfront" },
      { label: "Yes — but no upfront fee, payment on results", scores: { sell: 1 } },
      { label: "No, I'm researching on my own", scores: { hold: 1 } },
    ],
  },
  {
    question: "What's your timeline?",
    options: [
      { label: "As soon as possible", scores: { exit: 2, sell: 1 } },
      { label: "Within the next 6–12 months", scores: { sell: 1, hold: 1 } },
      { label: "No rush — just planning ahead", scores: { buy: 1, hold: 2 } },
    ],
  },
];

export const RESULTS = {
  buy: {
    title: "Buying more could genuinely suit you",
    summary: "You use your ownership, the fees feel fair, and you want more of it. Your edge is buying smart:",
    bullets: [
      "Look at the resale market before the developer's sales desk — the savings are usually dramatic.",
      "Run the cost-per-night maths before any presentation, and take 24 hours before signing anything.",
      "Chapter 01 below is written exactly for your situation.",
    ],
  },
  hold: {
    title: "Hold, review, and decide from a position of calm",
    summary: "Nothing in your answers says 'act now' — and that's a good place to be. Use the breathing room:",
    bullets: [
      "Review your actual usage and cost-per-night over the past two years.",
      "Ask your developer about rental, banking points or deed-back options you may not be using.",
      "Read Chapters 01 and 02 so your next move is deliberate, not reactive.",
    ],
  },
  sell: {
    title: "Selling is likely your strongest path",
    summary: "Usage is down and the fees are weighing on you. A realistic sale beats a hopeful one:",
    bullets: [
      "Check the developer's deed-back program first — often the cheapest exit of all.",
      "Price from completed resales of your resort, not from what you paid.",
      "Chapter 02 walks you through the whole process, step by step.",
    ],
  },
  exit: {
    title: "Explore a managed, verified exit",
    summary: "You want out — and the priority is doing it safely, without feeding the scam industry:",
    bullets: [
      "Never pay a large upfront fee. Use escrow or pay-on-results structures only.",
      "Verify any company's licence, complaint history and contract before engaging.",
      "Chapters 03 and 04 are essential reading before you sign with anyone.",
    ],
  },
};

export const FLAG_NOTE = "One caution from your answers: a company asking for a large upfront fee is the single biggest red flag in this industry. Read Chapter 04 before paying anyone anything.";

export const MARQUEE_ITEMS = ["Guidance", "Clarity", "Strategy", "Ownership", "Exit", "Resale", "Education", "Confidence"];
